import GenericGridCreator from 'ps-components/AdvancedTable/GenericGrid/GenericGridCreator';
import { JobDetails } from 'ps-components/AdvancedTable/GenericGrid/GenericGridCellRenderers';

const newGenericGrid = new GenericGridCreator(
  'SLOTTED_SEARCH',
  {},
  {
    defaultLeftColumns: [
      {
        Header: 'Job Title',
        stickyLeft: true,
        customRender: JobDetails,
        width: 260,
        accessor: null
      }
    ],
    hiddenTerms: [
      'field_org_job_code',
      'field_org_job_code_key',
      'field_org_job_title',
      'org_job_id_default',
      'org_job_code_default',
      'org_job_code_key_default',
      'org_job_description_default'
    ],
    tableProps: {
      useSelectAll: false
    }
  },
  {
    getInstanceState: store => store.marketPricing.SlottedSearchReducer.slottedSearchGridReducer
  }
);
export const slottedSearchGridActions = newGenericGrid.getActions();

export default newGenericGrid.createReducer();
